module.exports = __webpack_public_path__ + "img/service_valuation.9c01e562.png";